import * as FactoryActions from '../../action-creators/factories';
import * as busyCounter from '../../../../shared/action-creator/busy-counter';
import React, {
    PureComponent,
} from 'react';
import { getAdminFactories, getDefaultFactoryCode } from '../../repositories';
import OptionsDropDown from '../../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class Factories extends PureComponent {

    handleFactoriesChange = newValue => {

        this.props.updateFactoryCode( newValue );

    };

    componentWillMount = () => {

        this.props.increaseCounter();
        if ( this.props.accessToken ) {

            this.loadFactoryData();

        }

    }

    componentDidUpdate = prevProps => {

        if ( this.props.accessToken !== prevProps.accessToken ) {

            this.loadFactoryData();

        }

    }

    loadFactoryData = () => {

        getAdminFactories().then( response => {

            const recFactories = [];
            response.forEach( factory => {

                recFactories.push( {
                    factoryCode: factory.factoryCode,
                    factoryDescription: `${factory.factoryCode} - ${factory.factoryDescription}`,
                } );

            } );

            let defaultFactory = getDefaultFactoryCode();
            if ( defaultFactory === '' && recFactories.length > 0 ) defaultFactory = recFactories[0].factoryCode;
            this.props.loadFactories( recFactories );
            this.props.updateFactoryCode( defaultFactory );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    render = () => {

        const selectedValue = this.props.factoryCode ? this.props.factoryCode : '';
        const accessToken = this.props.accessToken !== '';

        return (
            <span>
                { accessToken && (
                    <OptionsDropDown
                        className={`factories-dropdown ${this.props.className}`}
                        isPlaceholderTranslated={true}
                        onChange={this.handleFactoriesChange}
                        optionDisplayAttributes={['factoryDescription']}
                        optionKey="factoryCode"
                        options={this.props.factories}
                        showPlaceholder={false}
                        selectedValue={selectedValue}
                    />
                ) }
            </span>
        );

    };

}

Factories.displayName = 'Factories';
Factories.propTypes = {
    factories: PropTypes.array.isRequired,
    updateFactoryCode: PropTypes.func.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    factoryCode: PropTypes.string.isRequired,
    accessToken: PropTypes.string.isRequired,
    loadFactories: PropTypes.func.isRequired,
};

const mapStateToProps = state => ( {
    factories: state.application.factories.factories,
    factoryCode: state.application.factories.factoryCode,
    accessToken: state.oktaState.oktaState.accessToken,
    // factoryCode: state.application.FactoryState.factoryCode//.application.factory
} );

const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    loadFactories: factory => dispatch( FactoryActions.loadFactories( factory ) ),
    updateFactoryCode: code => dispatch( FactoryActions.updateFactoryCode( code ) ),
} );
export default connect(
    mapStateToProps, mapDispatchToProps,
)( Factories );
